import { jsx as _jsx } from "react/jsx-runtime";
import './styles/App.css';
import TeacherRegistrationForm from './components/flows/RegistrationFlow';
const App = () => {
    return (_jsx("div", { className: "app", children: _jsx("main", { className: "app-main", children: _jsx(TeacherRegistrationForm, {}) }) }));
};
export default App;
